import {get, createSelector} from 'helpers';
import {store} from 'store';
import {byLocalMark} from 'store/activities/selectors/activities';
import {category} from 'store/common';
import {linkGoalActivities} from './actions';

const first = createSelector(
  [ byLocalMark, category ],
  ( byLocalMark, category ) => byLocalMark['clarity0-' + category],
)

const second = createSelector(
  [ byLocalMark, category ],
  ( byLocalMark, category ) => byLocalMark['clarity1-' + category],
)

export const activities = createSelector(
  [ category, first, second ],
  ( category, first, second ) => ({
    first: get(first, 'name', ''),
    second: get(second, 'name', ''),
    activities: [ first, second ].filter(Boolean),
    update: (value, name) => {
      const activity = [ first, second ][name];
      store.dispatch({
        type: value ? 'ACTIVITIES_UPDATE' : 'ACTIVITIES_DELETE',
        id: get(activity, 'id'),
        activity: {
          id: get(activity, 'id'),
          localMark: `clarity${name}-${category}`,
          name: value,
          category,
        }
      });
      linkGoalActivities(category);
    }
  }),
);

